import { ExclamationCircleFilled } from "@ant-design/icons";
import { message, Popconfirm } from "antd";
import { ReactNode } from "react";
import { useDeleteProductScenario } from "../../../useProducts";

export default function DeleteScenarioAction({
  productId,
  scenarioId,
  children,
}: {
  productId: number;
  scenarioId: number;
  children: ReactNode;
}) {
  const deleteScenario = useDeleteProductScenario();

  const onSubmit = async () => {
    return deleteScenario
      .mutateAsync({ productId, scenarioId })
      .then(() => message.success("Scenario deleted successfully."))
      .catch(() =>
        message.error("Something went wrong when deleting the scenario. Please try again.")
      );
  };

  return (
    <Popconfirm
      title={`Delete scenario`}
      description={
        <>
          <p>Deleting a scenario will also delete the connected BOM.</p>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      onConfirm={onSubmit}
      onCancel={() => {}}
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      okText={`Delete scenario`}
      cancelText="Cancel"
      placement="top"
      overlayStyle={{ width: "400px" }}
      okType="danger"
      okButtonProps={{ loading: deleteScenario.isLoading }}
    >
      {children}
    </Popconfirm>
  );
}
